import React, { useState, useEffect } from 'react';

import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';

const styles = {
    dialog: {
        contentStyle: {
            width: '100%',
            maxWidth: 'none',
        },
    },
    button: {
        labelStyle: { fontSize: '10px' },
        style: { height: '25px', margin: '0 10px 0 0' },
        buttonStyle: { height: '25px', lineHeight: '25px' },
    },
    textarea: {
        style: {
            width: '100%',
            minHeight: '400px',
        },
    },
};

// TODO: reuse that in other components

const TextEditor = (props) => {
    const [open, setOpen] = useState(false);
    const [textLetter, setTextLetter] = useState(props.textLetter);
    const [originalText, setOriginalText] = useState(props.originalText);

    useEffect(() => {
        setTextLetter(props.textLetter);
        setOriginalText(props.originalText);
    }, [props.textLetter, props.originalText]);

    const returnOriginalText = () => {
        setTextLetter(props.originalText);
    };

    const toggleDialog = () => {
        setOpen(!open);
    };

    const updateGazetters = async () => {
        if (textLetter) {
            toggleDialog();
            props.removeAnnotations();
            props.removeGazetters();
            await props.getLetterData(textLetter);
            props.updatePostGazetters(textLetter);
        }
    };

    const changeTextLetterText = (e) => {
        setTextLetter(e.target.value);
    };

    const actions = [
        <FlatButton
            label='RE-ANNOTATE'
            primary
            onClick={updateGazetters}
        />,
        <FlatButton
            label='RETURN ORIGINAL TEXT'
            primary
            onClick={returnOriginalText}
        />,
        <FlatButton
            label='CLOSE'
            primary
            onClick={toggleDialog}
        />,
    ];

    return (
        <div className='btn'>
            <RaisedButton
                label='Editor'
                labelStyle={styles.button.labelStyle}
                style={styles.button.style}
                buttonStyle={styles.button.buttonStyle}
                onClick={toggleDialog}
                primary
            />

            <Dialog 
                title='Edit letter text'
                actions={actions}
                contentStyle={styles.dialog.contentStyle}
                open={open}
                modal
            >
                <textarea 
                    style={styles.textarea.style}
                    value={textLetter}
                    onChange={changeTextLetterText}
                />
            </Dialog>
        </div>
    );
};

export default TextEditor;



// WEBPACK FOOTER //
// ./app/components/Letters/common/TextEditor.jsx